@if (showEditor()) {
  <div
    class="rich-text-editor"
    [class.rich-text-editor--disabled]="disabled()"
    [class.rich-text-editor--display-text-without-color]="displayTextWithoutColor()"
    [class.rich-text-editor--no-toolbar]="toolbarType === 'reduced'"
    [froalaEditor]="options"
    [(froalaModel)]="editorContent"
    (froalaInit)="initialize($event)"></div>
}
